const PageHeader = ({ title, subtitle, icon: Icon, actions, children }) => (
  <div className="dashboard-page-header">
    <div>
      <h1 className="dashboard-page-header__title">
        {Icon && <Icon className="dashboard-page-header__title-icon" aria-hidden="true" />}
        {title}
      </h1>
      {subtitle && <p className="dashboard-page-header__subtitle">{subtitle}</p>}
      {children}
    </div>
    {actions && <div className="dashboard-page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
